// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Grid, Row } from "react-bootstrap";
import PersonalDetails from "./PersonalDetails/";
import Scroll from "react-scroll"; // Imports all Mixins
import { scroller } from "react-scroll"; //Imports scroller mixin, can use as scroller.scrollTo()
import {
  fetchPaymentCountriesData,
  fetchPaymentCardTypesData
} from "../../actions/info";
import {
  lastBlurredField,
  validatePayment,
  makePayment
} from "../../actions/basket";
import {
  makeSelectData,
  makeSelectTransfers,
  makeSelectMoney,
  makeSelectOptions,
  makeSelectLoading,
  makeSelectError,
  makeSelectInfo,
  makeSelectPayment
} from "../QuotePage/selectors";
import Banner from "./Banner/";
import CardDetails from "./CardDetails/";
import { withRouter } from "react-router";

let Element = Scroll.Element;

class PaymentPage extends Component<void> {
  componentDidMount() {
    const scroll = Scroll.animateScroll;
    scroll.scrollToTop({ duration: 0 });
    this.props.fetchPaymentCountriesData(); //.then(result => console.log(result));
    this.props.fetchPaymentCardTypesData(); //.then(result => console.log(result));
  }

  componentDidUpdate(nextProps) {
    if (
      nextProps.payment.makePayment.makePaymentSuccess ||
      nextProps.payment.recordPayment.recordPaymentSuccess
    ) {
      setTimeout(() => {
        this.props.history.push("/complete");
      }, 100)
    }
  }

  handleCheckoutClick = () => {
    scroller.scrollTo("PersonalDetails", {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuint"
    });
  };

  render() {
    const paypalVersion = localStorage.getItem("ppv");
    if (!this.props.transfers) {
      return (
        <div className="text-center">
          <h1 style={{ color: "red" }}>Server Error</h1>
        </div>
      );
    }
    const inboundData = this.props.transfers[1]
      ? this.props.transfers[1]
      : null;
    return (
      <Grid className="payment-page" fluid>
         {paypalVersion !== "2" && (
        <Row className="banner">
          <Banner
            money={this.props.money}
            onClickCheckout={this.handleCheckoutClick}
            bookingId={this.props.basketData.bookingId}
            basketId={this.props.basketData.id}
            paymentRef={this.props.basketData.paymentRef}
          />
        </Row>
         )}
        <Row className="personal-details">
          <Element name="PersonalDetails" />
          <PersonalDetails
            inboundData={inboundData}
            money={this.props.money}
            outboundData={this.props.transfers[0]}
            bookingId={this.props.basketData.bookingId}
            paymentRef={this.props.basketData.paymentRef}
            basketData={this.props.basketData}
            info={this.props.info}
            basketId={this.props.basketData.id}
            lastBlurredField={this.props.lastBlurredField}
            lastBlurredState={this.props.lastBlurredState}
            validatePayment={this.props.validatePayment}
          />
        </Row>
        {paypalVersion !== "2" && (
          <Row className="card-details">
            <CardDetails
              info={this.props.info}
              basketId={this.props.basketData.id}
              lastBlurredField={this.props.lastBlurredField}
              lastBlurredState={this.props.lastBlurredState}
              validatePayment={this.props.validatePayment}
              basketData={this.props.basketData}
              makePayment={this.props.makePayment}
              payment={this.props.payment}
            />
          </Row>
        )}
      </Grid>
    );
  }
}

const lastBlurredState = state => state.basket.lastBlurredField;

const mapStateToProps = createStructuredSelector({
  basketData: makeSelectData(),
  transfers: makeSelectTransfers(),
  money: makeSelectMoney(),
  options: makeSelectOptions(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  info: makeSelectInfo(),
  payment: makeSelectPayment(),
  lastBlurredState
});

export default withRouter(
  connect(mapStateToProps, {
    fetchPaymentCountriesData,
    fetchPaymentCardTypesData,
    lastBlurredField,
    validatePayment,
    makePayment
  })(PaymentPage)
);



// WEBPACK FOOTER //
// ./src/containers/PaymentPage/index.js